var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"join__conten"},[_c('NavSecond',{attrs:{"banner":_vm.icon_stra}}),_vm._m(0),_c('div',{staticClass:"wrapper__w text__box animate__animated animate__fadeIn",domProps:{"innerHTML":_vm._s(_vm.base.content)}}),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title animate__animated animate__fadeIn"},[_c('span',[_vm._v("加入我们")])])
}]

export { render, staticRenderFns }